import moment from "moment";
import modelBaseV2 from "../../model-base-v2.model";
import { formats } from "../../../config/constants";

/**
 * Registration Single Channel Excel Model
 * 
 * Contains all the requests used by Registration Single Channel Excel
 * 
 * @author cmcnkhiep(Ryan)
 */
const RegistrationSingleChannelExcelModel = {
  getUserBackDateLimitDate: () => {
    return modelBaseV2.get('/api/user/backDateLimitDate');
  },
  uploadRegistrationExcelSingle: (payload) => {
    let body = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      body.append(key, value)
    })

    const filename = payload.excelRegistration?.name || 'test';

    return modelBaseV2.post('/api/datainput/registrationExcelSingle', { body }, filename);
  },
  downloadExcelTemplate: (fileName = "RegistrationSingleChannelTemplate") => {
    const exportConfig = {
      storedProcedureCode: "29",
      params: [],
      excelSheetNames: ["RegistrationSingleChannel"]
    };
    return modelBaseV2.postDownload("/api/executesp/export/file", { body: exportConfig }, fileName);
  },
  downloadResultFile: (fileId, fileName) => {
    return modelBaseV2.getDownload('/api/file/temp/:fileId', { params: { fileId } }, `${fileName}_${moment().format(formats.apiDateFormat)}`)
  },
  checkIsRAOrDealer: () => {
    return modelBaseV2.get('/api/user/isRADealer');
  },
  checkIsAcceptConsentBefore: () => {
    return modelBaseV2.get('/api/datainput/isRADealerConsentAddYN');
  },
  getConsentInfo: () => {
    return modelBaseV2.get('/api/user/isRADealerAndConsentYN');
  }
}

export default RegistrationSingleChannelExcelModel;